export default {
  path: '/elevator-trouble-logs',
  component: () => import('@/views/admin/elevator-trouble-logs/ElevatorTroubleLog.vue'),
}